var exports = {
  "v": "HomeView__Ja9074",
};

module.exports = exports;
